import Vue from 'vue/dist/vue.esm.js'
import Dropzone from 'dropzone'
KCVS.Views.MainView = Vue.extend(
  template: JST["procurement_documents/documents_table"]()
  data: ->
    canEdit: false
    isAdmin: false
    projectId: null
    procurementId: null
    competenceCenterId: null
    collection: []
    reportDocuments: []

  created: ->
    if @procurementId
      @fetchProcurementDocuments()
    @fetchReportDocuments()
    @initializeDropzone()

  methods:
    fetchProcurementDocuments: ->
      $.ajax
        url: "/procurements/#{@procurementId}/documents.json"
        method: 'GET'
        success: (data) =>
          @collection = data

    fetchReportDocuments: ->
      $.ajax
        url: "/admin/report_documents/procurement_project_report_documents.json"
        data: { project_id: @projectId, competence_center_id: @competenceCenterId }
        method: 'GET'
        success: (data) =>
          @reportDocuments = data

    initializeDropzone: ->
      AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
      Dropzone.autoDiscover = false

      @dropzone = new Dropzone(".dropzone",
        url: $(".dropzone").data("url")
        uploadMultiple: false
        addRemoveLinks: false
        dictDefaultMessage: I18n.t('javascript.dropzone.drop_here')
        dictCancelUpload: I18n.t('cancel')
        success: (file, doc) =>
          doc.new = true
          @fetchProcurementDocuments()
          @dropzone.removeFile(file)
        sending: (file, xhr, formData) ->
          formData.append("authenticity_token", AUTH_TOKEN)
      )

  components:
    procurementDocumentsItem: KCVS.Views.ItemView
)
